exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{height:100%}html,img{width:100%}*{margin:0;padding:0}html{font-family:Heiti SC,Microsoft YaHei;font-size:62.5%;outline:0;-webkit-text-size-adjust:none;-webkit-box-sizing:border-box}body{font-size:12px;font-size:1.2rem;-webkit-user-select:none;position:relative;background:#e0e0e0}p{font-size:14px;font-size:1.4rem}img{border:0;max-width:100%}.clearfix:after,.clearfix:before{display:table;content:\" \"}.clearfix:after{clear:both}a{text-decoration:none;-webkit-tap-highlight-color:transparent}ul li{list-style:none}.dp_none{display:block!important}@media screen and (min-width:375px){html{font-size:81.25%}}@media screen and (min-width:414px){html{font-size:87.5%}}@media screen and (min-width:500px){html{font-size:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/assets/css/wx_common.css
// module id = 43
// module chunks = 0